<template>
	<v-dialog
		v-if="dialog && !fkResolved"
		v-model="dialog"
		persistent
		max-width="460px"
	>
		<v-card>
			<v-card-title>
				<v-row no-gutters justify="center">
					<v-chip-group>
						<v-chip
							v-if="referenceField && referenceField.FormField"
						>
							{{ referenceField.FormField.Label }} :
							{{
								getFormFieldRecordValue(
									referenceField.FormField
								)
							}}
						</v-chip>
					</v-chip-group>
				</v-row>
				<v-card-subtitle v-if="!fkResolved">
					Please select a Value from the list below <br /><span>
						or Create New entry</span
					>
				</v-card-subtitle>
			</v-card-title>
			<div class="grid-flex-container">
				<v-row no-gutters>
					<v-text-field
						v-model="search"
						class="ma-0 pa-0 px-4"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						clearable
					/>
				</v-row>

				<div class="generic-grid-container">
					<v-data-table
						:headers="headers"
						:items="filteredItems"
						hide-default-footer
						:disable-pagination="true"
						dense
						fixed-header
						@click:row="onRowClicked"
					/>
				</div>
			</div>

			<v-card-actions>
				<v-spacer />
				<v-btn @click="close()">Cancel</v-btn>
				<v-btn class="primary" @click="onCreateNew()">Create New</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import gridViewFieldsUtils from '../../../utils/gridViewFieldsUtils';
import {
	InventoryFormFormGetters,
	InventoryFormGetters,
} from '../../../store/getters';
import { InventoryFormFormActions } from '../../../store/actions';
import { mapGetters } from 'vuex';
export default {
	name: 'CheckReferenceFieldsModal',
	props: {
		dialog: Boolean,
		referenceField: Object,
	},
	computed: {
		...mapGetters({
			record: [InventoryFormFormGetters.RECORD],
			referenceListValues: [
				InventoryFormGetters.GET_REFERENCE_LIST_VALUES,
			],
		}),
		currentInventoryFormId() {
			return this.$route.params.formId;
		},
		items() {
			if (!this.referenceField) return [];
			if (!this.referenceField.ReferenceListTypeId) return [];
			return this.referenceListValues.filter(
				(x) => x.TypeId == this.referenceField.ReferenceListTypeId
			);
		},
		filteredItems() {
			if (!this.search) return this.items;
			return this.items.filter(
				(x) =>
					x.Value &&
					x.Value.toLowerCase().includes(this.search.toLowerCase())
			);
		},
		totalCount() {
			if (!this.filteredItems) return 0;
			return this.filteredItems.length;
		},
	},
	data() {
		return {
			headers: [],
			fkResolved: true,
			search: null,
		};
	},
	mounted() {
		this.headers.push({
			text: this.referenceField.FormField.Label,
			value: 'Value',
			sortable: false,
		});
		let recordValue = this.getFormFieldRecordValue(
			this.referenceField.FormField
		);
		if (recordValue && this.items) {
			let refValues = this.items.filter(
				(x) =>
					x.Value &&
					x.Value.toLowerCase() == recordValue.toLowerCase()
			);
			if (refValues.length === 1) {
				if (
					refValues[0].Value.toLowerCase() ===
					recordValue.toLowerCase()
				) {
					this.onSubmit(refValues[0]);
				} else {
					this.fkResolved = false;
				}
			} else {
				this.fkResolved = false;
			}
		} else {
			this.fkResolved = false;
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onCreateNew() {
			let keys = [];
			let idKey = this.referenceField.IdKey;
			keys.push({ key: idKey, value: -1 });

			this.$store
				.dispatch(InventoryFormFormActions.UPDATE_RECORD_KEY, keys)
				.then(() => {
					this.$emit('submit');
				});
		},

		onSubmit(item) {
			let keys = [];
			let idKey = this.referenceField.IdKey;
			keys.push({ key: idKey, value: item.Id });

			let recordKey = gridViewFieldsUtils.getFieldName(
				this.referenceField.FormField.GridViewFields[0]
			);
			keys.push({ key: recordKey, value: item.Value });

			this.$store
				.dispatch(InventoryFormFormActions.UPDATE_RECORD_KEY, keys)
				.then(() => {
					this.$emit('submit');
				});
		},

		onRowClicked(item) {
			this.onSubmit(item);
		},

		getFormFieldRecordValue(formField) {
			if (!formField) return null;
			if (!formField.GridViewFields) return null;
			if (formField.GridViewFields.length === 1) {
				let key = gridViewFieldsUtils.getFieldName(
					formField.GridViewFields[0]
				);
				return this.record[key];
			}
			return null;
		},
	},
};
</script>
